import React from 'react';

export const defaultContextValue = { dataSource: null };

const QueryContext = React.createContext(defaultContextValue);

export default QueryContext;
